import { CreditCard } from '@benzinga/user-ui';
import { Select } from 'antd';
import styled from 'styled-components';
import { CreditCardProps } from './types';

export const RenderUpsellCreditCards: React.FC<CreditCardProps> = props => {
  if (!props.creditCards) return null;
  if (props.creditCards.length === 0)
    return <NoCardMessage>Please add a card in your account billing section </NoCardMessage>;
  if (props.creditCards.length === 1) {
    props.handleCreditCardSelection(props.creditCards[0]);
    return <CreditCard card={props.creditCards[0]} />;
  }

  return (
    <CardSelect
      labelInValue
      onChange={value => {
        const selectedCard =
          props.creditCards && props.creditCards.find(card => card.uuid === (value as { value: string }).value);
        if (selectedCard) {
          props.handleCreditCardSelection(selectedCard);
        }
      }}
      options={props.creditCards.map(card => ({
        label: (
          <CreditCardItemWrapper>
            <CreditCard card={card} />
          </CreditCardItemWrapper>
        ),
        value: card.uuid,
      }))}
      placeholder="Select a card"
      value={
        props.selectedCard
          ? {
              label: (
                <CreditCardItemWrapper>
                  <CreditCard card={props.selectedCard} />
                </CreditCardItemWrapper>
              ),
              value: props.selectedCard.uuid,
            }
          : undefined
      }
    />
  );
};
const NoCardMessage = styled.span`
  padding: 4px;
`;

const CardSelect = styled(Select)`
  height: max-content;
  padding: 0px;
`;

const CreditCardItemWrapper = styled.div`
  padding-top: 8px;
`;
